import { LayoutComponent } from "@jelly/lesson";
import config from "appConfig";

const components: LayoutComponent[] = [
  {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/03/15/principle/principle-1-path.svg`,
        },
      },
      styles: {
        padding: "5%",
      },
    },
  },
];

export default components;
